export default "__VITE_ASSET__Bf4O1pB1__"